import React, { useState } from "react";
import { AdSettingClassified } from "../../../../types/main-types/mainTypes";
import { Link, useNavigate } from "react-router-dom";
import {
  hideClassified,
  showClassified,
} from "../../../../services/main-service/mainService";
import AdBoostPopup from "../ad-boost-popup/AdBoostPopup";
import AdDeletePopup from "../ad-delete-popup/AdDeletePopup";
import { toastError, toastSuccess } from "../../../../utils/toast";
import { FaEllipsisV } from "react-icons/fa";
import { formatEpochTime } from "../../../../utils/timeConvertors";

interface AdSettingRowProps {
  adDetails: AdSettingClassified;
}

function approvalBadgeClass(status: string) {
  if (status === "approved") return "status-badge status-badge--approved";
  if (status === "rejected") return "status-badge status-badge--rejected";
  return "status-badge status-badge--pending";
}

function boostBadgeClass(type: string) {
  if (type === "featured") return "status-badge status-badge--featured";
  if (!type || type === "none") return "status-badge status-badge--none";
  return "status-badge status-badge--standard";
}

function AdSettingRow({ adDetails }: AdSettingRowProps) {
  const navigate = useNavigate();
  let [hidden, setHidden] = useState<boolean>(adDetails.hidden);

  async function handleVisibility() {
    let payload = { id: adDetails.id };
    try {
      if (hidden) {
        await showClassified(payload);
        toastSuccess("Ad is now visible!");
        setHidden(false);
      } else {
        await hideClassified(payload);
        toastSuccess("You've successfully hidden the ad!");
        setHidden(true);
      }
    } catch (error: any) {
      toastError(error.response.data.message);
    }
  }

  const adTitle =
    [adDetails.model, adDetails.make, adDetails.year]
      .filter(Boolean)
      .join(" ") || "Untitled";

  return (
    <tr>
      <td>
        <Link to={`/ads/${adDetails.id}`} className="listing-link">
          {adTitle}
        </Link>
      </td>
      <td>
        <span className={approvalBadgeClass(adDetails.approval_status)}>
          {adDetails.approval_status}
        </span>
      </td>
      <td style={{ color: "#64748b", fontSize: "0.8125rem" }}>
        {adDetails.approved_at
          ? formatEpochTime(Number(adDetails.approved_at))
          : "—"}
      </td>
      <td>
        <span className={boostBadgeClass(adDetails.boost_type)}>
          {adDetails.boost_type || "none"}
        </span>
      </td>
      <td style={{ color: "#64748b", textTransform: "capitalize" }}>
        {adDetails.boost_status.replaceAll("-", " ")}
      </td>
      <td style={{ color: "#64748b", fontSize: "0.8125rem" }}>
        {adDetails.boost_ends_at !== ""
          ? formatEpochTime(Number(adDetails.boost_ends_at))
          : "—"}
      </td>
      <td>
        <div className="dropdown">
          <button
            className="action-menu-btn"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <FaEllipsisV size={14} />
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button
                className="dropdown-item"
                data-bs-toggle="modal"
                data-bs-target={`#staticBackdrop_${adDetails.id}`}
              >
                Boost
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={handleVisibility}>
                {hidden ? "Show" : "Hide"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => navigate("/update-ad", { state: adDetails })}
              >
                Edit
              </button>
            </li>
            <li>
              <button
                className="dropdown-item text-danger"
                data-bs-toggle="modal"
                data-bs-target={`#staticBackdrop_delete_${adDetails.id}`}
              >
                Delete
              </button>
            </li>
          </ul>
        </div>
      </td>
      <td style={{ padding: 0 }}>
        <AdBoostPopup adDetails={adDetails} />
        <AdDeletePopup adDetails={adDetails} />
      </td>
    </tr>
  );
}

export default AdSettingRow;
